// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Configuration/Operator';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useOperatorConfigurations: () => UseQueryResult<
  TemplateContract<OperatorConfiguration>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  // COLLATERAL: fix
  const { operator } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryCollateralOperatorConfigurationsV2', operator],
    enabled: !!operator,
    select: (data: TemplateContract<OperatorConfiguration>[]) =>
      data.filter((d) => d.payload.operator === operator),
    queryFn: async (_, options) => {
      return ledgerApi.query(options, OperatorConfiguration);
    },
  });
};

export default useOperatorConfigurations;
